import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import { PurchaseInfosApi } from "../../../../../apis/PurchaseInfosApi";
import { useEffect } from "react";
import { CustomBackdropController } from "../../../../../components/backdrop/default/v1";
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import { AnalyticsApi } from "../../../../../apis/AnalyticsApi";
import { CustomDateUtils } from "../../../../../utils/CustomDateUtils";

const QUERY_KEY = 'orderQtyList';

export function useOrderQtyListQuery({
    productOptionIds
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const queryResult = useQuery({
        queryKey: [QUERY_KEY, productOptionIds],
        enabled: !!(apiInfoContextValueHook?.apiInfo?.apiKey && apiInfoContextValueHook?.apiInfo?.secretKey && productOptionIds?.length > 0),
        queryFn: async () => {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            })

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            }
            const fetchResult = await AnalyticsApi().searchOrderQty({
                headers: headers,
                body: {
                    indexType: "ID",
                    dateType: "CREATED_AT",
                    timezone: CustomDateUtils().getClientTimezoneName(),
                    fromDate: CustomDateUtils().dateToYYYYMMDD(new Date()),
                    toDate: CustomDateUtils().dateToYYYYMMDD(new Date()),
                    payload: productOptionIds
                }
            })

            return fetchResult;
        }
    });

    useEffect(() => {
        if (queryResult.isLoading) {
            CustomBackdropController().showBackdrop();
        } else {
            CustomBackdropController().hideBackdrop();
        }
    }, [queryResult.isLoading]);

    return queryResult;
}